import { useContext, useEffect, useState } from 'react'
import { UNSAFE_NavigationContext } from 'react-router-dom'

import { interceptNavigator, preventUnload } from './helpers'

const useUnsavedChangesGuard = ({ hasUnsavedChanges }) => {
  const { navigator } = useContext(UNSAFE_NavigationContext)
  const [pendingNavigation, setPendingNavigation] = useState(null)
  const [isDiscarded, setIsDiscarded] = useState(false)

  const isGuarding = hasUnsavedChanges && !isDiscarded

  useEffect(() => {
    if (!hasUnsavedChanges) setIsDiscarded(false)
  }, [hasUnsavedChanges])

  useEffect(() => {
    if (!isGuarding) return undefined

    window.addEventListener('beforeunload', preventUnload)

    return () => window.removeEventListener('beforeunload', preventUnload)
  }, [isGuarding])

  useEffect(() => {
    if (!isGuarding) return undefined

    return interceptNavigator(navigator, setPendingNavigation)
  }, [isGuarding, navigator])

  const handleKeepEditing = () => setPendingNavigation(null)

  const handleDiscardChanges = () => {
    setIsDiscarded(true)
    pendingNavigation.navigate()
    setPendingNavigation(null)
  }

  return { showUnsavedChangesModal: Boolean(pendingNavigation), handleKeepEditing, handleDiscardChanges }
}

export default useUnsavedChangesGuard
